// Unpublished Work © 2025-2026 Deere & Company.
import {createUserSession} from '../user-session-details';

const isValidArgs = (userId) => Boolean(userId);

const getAppName = (applicationName) => applicationName || '';

export const logUserEntry = (applicationName, userId) => {
    if (!isValidArgs(userId)) {
        return;
    }

    createUserSession(userId, getAppName(applicationName));
};
